// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-theme-homestead -> apartment-management-consultants-theme-homestead-milburn -> woodgate
// Generated: 2026-08-21T22:01:00.405Z
// Counts: 7 design, 40 content, 22 slot group, 0 collection binding, 7 section, 0 style

export const designOverrides = {
  "design._site.color.accent": {
    "cssVariable": "--vibe-color-accent",
    "overrideType": "FIELD_MAPPING",
    "value": null,
    "mappedField": "property_color_3"
  },
  "design._site.color.surface": {
    "cssVariable": "--vibe-color-surface",
    "overrideType": "FIELD_MAPPING",
    "value": null,
    "mappedField": "property_secondary_color"
  },
  "design._site.color.textMuted": {
    "cssVariable": "--vibe-color-text-muted",
    "overrideType": "VALUE",
    "value": "#303030",
    "mappedField": null
  },
  "design._site.font.accent": {
    "cssVariable": "--vibe-font-accent",
    "overrideType": "VALUE",
    "value": "'DM Sans', sans-serif",
    "mappedField": null
  },
  "design._site.font.body": {
    "cssVariable": "--vibe-font-body",
    "overrideType": "VALUE",
    "value": "'DM Sans', sans-serif",
    "mappedField": null
  },
  "design._site.font.heading": {
    "cssVariable": "--vibe-font-heading",
    "overrideType": "VALUE",
    "value": "'DM Sans', sans-serif",
    "mappedField": null
  },
  "design._site.font.mono": {
    "cssVariable": "--vibe-font-mono",
    "overrideType": "VALUE",
    "value": "'DM Sans', sans-serif",
    "mappedField": null
  }
};

export const contentOverrides = {
  "audioeye-widget.cta_color": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_primary_color"
  },
  "audioeye-widget.cta_location": {
    "overrideType": "VALUE",
    "customValue": "left-lower",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Nestled in West Jordan, Woodgate offers not just <a href=\"https://www.woodgateapts.net/floor-plans/\">stylish one, two, and three-bedroom apartments</a>, but also a vibrant lifestyle. Enjoy nearby attractions like the Utah Olympic Oval, Maverik Center, and EōS Fitness. From parks to shopping at Fashion Place, your ideal living experience awaits. Check out our community’s local gems!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.description": {
    "overrideType": "VALUE",
    "customValue": "<p> <span> <span>At Woodgate in West Jordan, UT, your ideal apartment awaits! Choose from <a href=\"https://www.woodgateapts.net/floor-plans/\">spacious one, two, or three-bedroom layouts</a>, complete with stylish finishes and modern amenities. Relax by the pool, get fit in our gym, or unwind outside. Your vibrant community lifestyle begins here—come see for yourself!</span> </span> </p>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Embrace the Comfort of Your New Home</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "feeguide.aim_code": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_aim_property_code"
  },
  "floor-plans-hero.overline": {
    "overrideType": "VALUE",
    "customValue": "<p>1 - 3 Bedroom Apartments</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanslist.heading": {
    "overrideType": "VALUE",
    "customValue": "<p>Find Your Perfect Home</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Woodgate in West Jordan, UT, comfort meets convenience. Choose from spacious one to three-bedroom floor plans, and enjoy resort-style amenities like a sparkling pool, fitness center, and dog park. With features such as granite countertops and high-speed internet, your ideal home awaits – a place to unwind, socialize, and thrive.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-hero.overline": {
    "overrideType": "VALUE",
    "customValue": "<p>Experience Lifestyle-Enhancing Features</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Amenities</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apply-now-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p> <span>At Woodgate in West Jordan, UT, choose from spacious one, two, or three-bedroom apartments designed for comfort and convenience. Enjoy resort-style amenities like a sparkling pool, fitness center, and cozy lounge. With pet-friendly spaces and vibrant social activities, your ideal home awaits. Secure your spot and lease online today!</span> <span> <span></span> </span> </p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apply-now-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Apply Now</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Woodgate in West Jordan, UT, our thoughtfully designed floor plans include one, two, and three-bedroom options tailored to suit your lifestyle. Experience comfort and community in a welcoming environment. Have questions? Contact our leasing team today for personalized assistance and to find your perfect home!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-hero.overline": {
    "overrideType": "VALUE",
    "customValue": "<p>Reach Out to Learn More</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Contact Us</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p> <span> <span>At Woodgate in West Jordan, UT, our thoughtfully designed floor plans cater to every lifestyle. Choose from cozy one-bedroom retreats, spacious two-bedroom havens, or luxurious three-bedroom spaces, each tailored for comfort and style. Browse our available apartment homes today to find the perfect fit for your next chapter.</span> </span> </p>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Floor Plans</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanslist.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p> <span> <span>At Woodgate in West Jordan, UT, your ideal living space awaits! Choose from our thoughtfully designed one, two, or three-bedroom floor plans, each crafted for comfort and style. Browse our available apartment homes today and step into a lifestyle that perfectly fits your vision of home.</span> </span> </p>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Woodgate in West Jordan, UT, our vibrant community invites you to envision a life enhanced by <a href=\"https://www.woodgateapts.net/amenities/\">resort-style amenities</a>. From relaxing by the pool to enjoying a picnic with friends in our lush courtyard, every moment feels like a getaway. Picture yourself living here, surrounded by comfort and convenience!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-hero.overline": {
    "overrideType": "VALUE",
    "customValue": "<p>Explore Our Photo Gallery</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Gallery</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>1 - 3 Bedroom Apartments in West Jordan , UT</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Woodgate</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-hero.overline": {
    "overrideType": "VALUE",
    "customValue": "<p>Ideally Located in West Jordan , UT</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Neighborhood</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "parallaxbanner.eyebrow": {
    "overrideType": "VALUE",
    "customValue": "<p>Tour Anytime. From Any Distance.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "parallaxbanner.title": {
    "overrideType": "VALUE",
    "customValue": "<p>We're Here For You</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "pet-policy-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Woodgate in West Jordan, UT, your furry friends are part of the family! With ample green spaces and a welcoming community, we invite you and your pets to thrive together. Enjoy life with your dogs and cats while adhering to our reasonable breed restrictions and pet policies.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "pet-policy-hero.overline": {
    "overrideType": "VALUE",
    "customValue": "<p>Living with Your Pet</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "pet-policy-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Pet Policy</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p> <span> <span>Pets welcome! Breed restrictions apply. Pet fee: $300 per pet. Pet deposit: $100. Monthly pet rent: $60 per pet. Maximum 2 pets per unit.</span> </span> </p>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Living with Your Pet</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Woodgate in West Jordan, UT, our <a href=\"https://www.woodgateapts.net/floor-plans/\">spacious floor plans cater to every lifestyle, offering one, two, and three-bedroom</a> options designed for comfort and convenience. Schedule a tour today to experience our vibrant community and hear firsthand from residents about their amazing living experience!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-hero.overline": {
    "overrideType": "VALUE",
    "customValue": "<p>Take a Tour of Woodgate</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Schedule A Tour</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "thankyoucontent.body": {
    "overrideType": "VALUE",
    "customValue": "<p>Thank you for reaching out to Woodgate in West Jordan, UT! Our diverse floor plans—ranging from cozy one-bedroom to spacious three-bedroom apartments—cater to all lifestyles. Expect a team member to connect with you soon to help you find your perfect home!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Step inside Woodgate, the premier apartment community in West Jordan, UT, where comfort meets style. Choose from our thoughtfully designed one, two, and three-bedroom floor plans to find your perfect fit. Experience the charm of our community—take a virtual tour today and envision your new home!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-hero.overline": {
    "overrideType": "VALUE",
    "customValue": "<p>Take a Virtual Tour of Our Community</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Virtual Tours</p>",
    "generatedValue": null,
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "propertyoverview.cta_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "VALUE",
        "customValue": "Find Your Home"
      },
      "url": {
        "type": "VALUE",
        "customValue": "/floor-plans"
      }
    }
  },
  "floorplanslist.contact_cta": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "VALUE",
        "customValue": "Explore The Area"
      },
      "url": {
        "type": "VALUE",
        "customValue": "/neighborhood"
      }
    }
  },
  "floorplanslist.view_all_cta": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/amenities"
      },
      "label": {
        "type": "VALUE",
        "customValue": "View Amenities"
      }
    }
  },
  "footer.managed_by_logo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "FIELD_MAPPING",
        "mappedField": "property_company_logo"
      },
      "alt": {
        "type": "FIELD_MAPPING",
        "mappedField": "property_company_logo_media.alt_text"
      }
    }
  },
  "header.resident_access_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "FIELD_MAPPING",
        "mappedField": "property_resident_portal_url"
      },
      "label": {
        "type": "VALUE",
        "customValue": "Resident Login"
      }
    }
  },
  "header.schedule_tour_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "VALUE",
        "customValue": "Schedule A Tour"
      }
    }
  },
  "herocallouts.cta1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "VALUE",
        "customValue": "View Pricing & Availability"
      },
      "url": {
        "type": "VALUE",
        "customValue": "/floor-plans/"
      }
    }
  },
  "petpolicy.cta_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "VALUE",
        "customValue": "Explore All Amenities"
      }
    }
  },
  "herocallouts.cta2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "VALUE",
        "customValue": "Take a Virtual Tour"
      },
      "url": {
        "type": "VALUE",
        "customValue": "/virtual-tour/"
      }
    }
  },
  "herocallouts.cta3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "VALUE",
        "customValue": "Explore Our Amenities"
      },
      "url": {
        "type": "VALUE",
        "customValue": "/amenities/"
      }
    }
  },
  "herocallouts.cta4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "VALUE",
        "customValue": "Browse The Gallery"
      },
      "url": {
        "type": "VALUE",
        "customValue": "/gallery/"
      }
    }
  },
  "imagecallouts.tile1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166460/019f778e-cb90-733a-b494-04bf0434b739.webp"
      }
    }
  },
  "imagecallouts.tile2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166460/019f778e-cb90-733a-b494-09ee49551b21.webp"
      }
    }
  },
  "imagecallouts.tile3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166460/019f778e-cb8f-774d-94a1-e95f48c69aeb.webp"
      }
    }
  },
  "imagecallouts.tile4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166460/019f778e-cbcf-7118-b2c3-82d6e5f7228e.webp"
      }
    }
  },
  "parallaxbanner.primary_cta": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "VALUE",
        "customValue": "Schedule a Visit"
      },
      "url": {
        "type": "VALUE",
        "customValue": "/schedule-a-tour"
      }
    }
  },
  "parallaxbanner.secondary_cta": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "VALUE",
        "customValue": "Take a Virtual Tour"
      },
      "url": {
        "type": "VALUE",
        "customValue": "/virtual-tour"
      }
    }
  },
  "petpolicy.image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166460/019f778e-dc8f-7754-8bca-4ccb0d1ac25e.webp"
      }
    }
  },
  "socialconnect.image1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166460/019f778e-cb90-733a-b494-09ee49551b21.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Cozy bedroom with a queen-size bed, plush bedding, and a large window with city views."
      }
    }
  },
  "socialconnect.image2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166460/019f778e-cb90-733a-b494-04bf0434b739.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Billiard table and bar area in the apartment clubhouse lounge."
      }
    }
  },
  "socialconnect.image3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166460/019f778e-cb8f-774d-94a1-e95f48c69aeb.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Rooftop lounge area with bar, seating, and string lights overlooking city."
      }
    }
  },
  "socialconnect.image4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166460/019f778e-cbcf-7118-b2c3-82d6e5f7228e.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern dining area with plush seating, large tables, and contemporary chandeliers."
      }
    }
  }
};

export const collectionBindingOverrides = {};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "apartment-sync-loader",
      "blockId": "apartment-sync-loader",
      "position": 0
    },
    {
      "sectionId": "audioeye-widget",
      "blockId": "audioeye-widget",
      "position": 0
    },
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    },
    {
      "sectionId": "multihub-lead-capture",
      "blockId": "multihub-lead-capture",
      "position": 0
    },
    {
      "sectionId": "anyonehome-chatbot",
      "blockId": "anyonehome-chatbot",
      "position": 0
    },
    {
      "sectionId": "lea-chatbot",
      "blockId": "lea-chatbot",
      "position": 0
    }
  ]
};

export const styleOverrides = {};
